import { render, staticRenderFns } from "./bandAandB.vue?vue&type=template&id=5028be3f&scoped=true"
import script from "./bandAandB.vue?vue&type=script&lang=js"
export * from "./bandAandB.vue?vue&type=script&lang=js"
import style0 from "./bandAandB.vue?vue&type=style&index=0&id=5028be3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028be3f",
  null
  
)

export default component.exports